module.exports = __webpack_public_path__ + "static/media/hevde.f33f9c9e.m4a";